import { Component, ElementRef, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-example-monouse-component",
  template: ``,
  styles: [],
  standalone: false,
})
export class OpenModalBookingComponent implements OnInit {
  @Input() fatherElement: any = {};
  @Input() fatherContaierRef: any;
  needToOpen = false;

  constructor(private host: ElementRef<HTMLElement>) { }

  ngOnInit(): void {
    setTimeout(() => {
      const url = new URL(window.location.href);
      const params = url.searchParams;
      const id = params.get("id");
      if (!id) {
        this.needToOpen = false;
        return;
      }
      this.fatherContaierRef.filtersList = [
        {
          "s": "id",
          "v": id,
          "o": 1,
        }
      ]
      this.fatherContaierRef.getTableData()
      this.checkIsLoaded()
    }, 1);
  }

  checkIsLoaded(){
    if(this.fatherContaierRef?.dataTable?.length == 1){
      this.fatherContaierRef.currentItem = this.fatherContaierRef?.dataTable[0]
      this.fatherContaierRef.initEdit()
    }else{
      setTimeout(() => {
        this.checkIsLoaded()
      }, 100);
    }
  }
}
